export function formatAmountString(raw) {
  if (raw === null || raw === undefined) return "";

  const cleaned = String(raw).replace(/,/g, "").replace(/[^\d.]/g, "");
  if (!cleaned) return "";

  const parts = cleaned.split(".");
  const whole = parts[0].replace(/^0+(?=\d)/, "") || "0";
  const formattedWhole = Number(whole).toLocaleString("en-US");

  if (parts.length > 1) {
    return `${formattedWhole}.${parts[1].slice(0, 2)}`;
  }

  return formattedWhole;
}

export function attachAmountFormatter(input) {
  if (!input || input.dataset.amountFormatterAttached) return;
  input.dataset.amountFormatterAttached = "true";

  function syncAdornment() {
    if (window.App && window.App.syncInputAdornmentForInput) {
      window.App.syncInputAdornmentForInput(input);
    }
  }

  if (input.value) {
    input.value = formatAmountString(input.value);
    syncAdornment();
  }

  input.addEventListener("input", function () {
    this.value = formatAmountString(this.value);
    if (window.App && window.App.syncInputAdornmentForInput) {
      window.App.syncInputAdornmentForInput(this);
    }
  });

  input.addEventListener("focus", syncAdornment);
  input.addEventListener("blur", syncAdornment);

  input.addEventListener("keypress", function (e) {
    if (!/[0-9.]/.test(e.key)) {
      e.preventDefault();
    }
  });

  if (window.App && window.App.refreshInputAdornments) {
    window.App.refreshInputAdornments(input.closest(".custom-floating") || input.parentElement);
  }
}

export function formatAmountFields(ids = []) {
  ids.forEach((id) => {
    const input = document.getElementById(id);
    if (!input) return;

    if (!input.dataset.amountFormatterAttached) {
      attachAmountFormatter(input);
      return;
    }

    if (input.value) {
      input.value = formatAmountString(input.value);
    }
  });
}
